import { connect } from "react-redux";
import {withRouter} from "react-router"
import WIPreview from "./WIPreview"
import { fetchAllWorkInstructions, previewWorkInstruction } from "../../../../redux/actions/wi_actions"
import { oversightVerification } from "../../../../redux/actions/user_actions"

const mapStateToProps = (state, ownProps) => {
    console.log("maps to state preview");
    console.log(state)
    let setVS = false;
       if (state.users.length !== 0){
            console.log("users list there");
            console.log(state.users)
           if(typeof state.users.VERIFY_SUPERVISOR !== "undefined"){
            console.log("vs there");
            console.log(state.users.VERIFY_SUPERVISOR);
            setVS = true
           }
       }

       if (setVS){
           console.log("it worked")
        return ({
            workInstruction: state.previewer,
            verifySupervisor: state.users.VERIFY_SUPERVISOR 
        });
       }else{
        return ({
            workInstruction: state.previewer
        });
       }

   

   
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return ({
        fetchAllWorkInstructions: () => dispatch(fetchAllWorkInstructions()),
        previewWorkInstruction: () => dispatch(previewWorkInstruction(ownProps.location.pathname.split('/').pop())),
        oversightVerficiation: (creds) => dispatch(oversightVerification(creds))
    });
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WIPreview))